import { Deserializable } from "./deserializable";
import { DeviceDetectorService } from "ngx-device-detector";

export class UserInformaions implements Deserializable {
  connexionDate: Date;
  support: string;
  navigateur: string;
  pays: string;
  lieu: string;
  adresseIp: string;

  constructor(
    connexionDate,
    deviceService: DeviceDetectorService,
    pays,
    lieu,
    adresseIp
  ) {
    this.connexionDate = connexionDate;
    if (deviceService) {
      this.navigateur = deviceService.getDeviceInfo().browser;
      if (deviceService.isDesktop()) {
        this.support = "PC";
      } else if (deviceService.isTablet()) {
        this.support = "Tablette";
      } else if (deviceService.isMobile()) {
        this.support = "Mobile";
      } else {
        this.support = deviceService.getDeviceInfo().device;
      }
    }
    this.pays = pays;
    this.lieu = lieu;
    this.adresseIp = adresseIp;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}



// WEBPACK FOOTER //
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/common/userinformations.ts